export const RotationSteps = {
  0: 0,
  1: 90,
  2: 180,
  3: 270,
};
